import { CenterScreenComponent, Link, StatusBadge } from '../../components';
import {
    ModerationGroupQuery,
    useMeQuery,
    useModerationDashboardQuery,
    useModerationGroupQuery,
} from '../../generated/graphql';

import { ListGroup } from 'react-bootstrap';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { UsersList } from './components/UsersList';
import routes from '../../routes/routes';

interface GroupScreenParams {
    id: string;
}

type Users = NonNullable<ModerationGroupQuery['group']>['users'];

type ModerationGroupScreenProps = RouteComponentProps<GroupScreenParams>;

export const ModerationGroupScreen: React.FC<ModerationGroupScreenProps> = ({ history, location, match }) => {
    const id = match.params?.id;
    const me = useMeQuery();
    const { data, loading, error } = useModerationGroupQuery({ variables: { id: Number(id || me.data?.me?.groupId) } });

    const dashboardData = useModerationDashboardQuery({
        variables: { id: Number(me.data?.me?.groupId) },
        skip: !me.data?.me?.id,
    });

    if (loading || dashboardData.loading || me.loading) {
        return <CenterScreenComponent>Завантаження...</CenterScreenComponent>;
    }

    const group = data?.group;

    const status0: Users = [];
    const status1: Users = [];

    group?.users?.forEach((user) => {
        if (user.statuses.status0) {
            status0.push(user);
            return;
        }

        status1.push(user);
    });

    if (!me.data?.me?.admin && !me.data?.me?.moderator) {
        return null;
    }

    if (error) {
        return <CenterScreenComponent>Помилка...</CenterScreenComponent>;
    }

    return (
        <div>
            <div></div>
            <h3>Назва групи: {group?.name}</h3>
            <Link href={`${routes.generateResult}/${Number(id || me.data?.me?.groupId)}`}>Згенерувати результат</Link>
            <ListGroup>
                {group?.children?.map((childrenItem) => {
                    return (
                        <ListGroup.Item
                            key={childrenItem.id}
                            onClick={() => history.push(`${routes.moderationGroup}/${childrenItem.id}`)}
                            style={{ cursor: 'pointer' }}
                        >
                            {childrenItem.name}
                        </ListGroup.Item>
                    );
                })}
                <UsersList usersList={status0} title="Користувачі з неопрацьованими документами" />
                <UsersList usersList={status1} title="Користувачі з опрацьованими документами" />
            </ListGroup>
        </div>
    );
};
